import { render, staticRenderFns } from "./TopLangs.vue?vue&type=template&id=a127d0d2&scoped=true&"
import script from "./TopLangs.vue?vue&type=script&lang=js&"
export * from "./TopLangs.vue?vue&type=script&lang=js&"
import style0 from "./TopLangs.vue?vue&type=style&index=0&id=a127d0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a127d0d2",
  null
  
)

export default component.exports